import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import clsx from 'clsx';
import { Button, Gapped, Input, Modal, Textarea, Toast } from '@skbkontur/react-ui';
import classes from './Feedback.module.css';
const RateInfos = [
    {
        caption: 'Отлично',
        text: 'Расскажите, что вам понравилось',
        label: '5',
    },
    {
        caption: 'Хорошо',
        text: 'Расскажите, что мы могли бы улучшить',
        label: '4',
    },
    {
        caption: 'Нормально',
        text: 'Расскажите, что вам не понравилось, или чего не хватает',
        label: '3',
    },
    {
        caption: 'Плохо',
        text: 'Нам жаль, что мы не оправдали ваших ожиданий. Расскажите, с чем возникли проблемы',
        label: '2',
    },
    {
        caption: 'Ужасно',
        text: 'Нам жаль, что мы не оправдали ваших ожиданий. Расскажите, с чем возникли проблемы',
        label: '1',
    },
];
export class Feedback extends React.Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "headerText", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: this.props.headerText || 'Оцените удобство'
        });
        Object.defineProperty(this, "state", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                hoverRating: undefined,
                rating: undefined,
                message: '',
                contactInfo: '',
            }
        });
        Object.defineProperty(this, "handleClose", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                if (this.state.rating) {
                    Toast.push('Спасибо за оценку, вы помогаете нам стать лучше');
                    this.props.onRate({ ...this.state, rating: this.state.rating });
                    this.props.onClose();
                    return;
                }
                this.props.onClose();
            }
        });
        Object.defineProperty(this, "handleStarMouseOver", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (rate) => {
                this.setState({ hoverRating: rate });
            }
        });
        Object.defineProperty(this, "handleStarMouseOut", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.setState({ hoverRating: undefined });
            }
        });
        Object.defineProperty(this, "handleStarClick", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (rate) => {
                this.props.onStarClick && this.props.onStarClick(rate);
                this.setState({ rating: rate });
            }
        });
    }
    render() {
        const { hoverRating, rating } = this.state;
        const ratingCaption = hoverRating ? hoverRating.caption : rating ? rating.caption : 'Оценка';
        const { children, commentOpened, onBackClick, onClose, title, type } = this.props;
        const isTypeFull = type === 'full';
        const isTypeShort = type === 'short';
        const textTop = isTypeShort ? (_jsx("h2", { className: classes.headerCentered, children: this.headerText })) : (_jsxs("div", { children: [_jsx("div", { className: classes.description, children: children }), _jsx("div", { className: classes.title, children: title })] }));
        const primaryButton = () => {
            if (isTypeFull) {
                return (_jsx(Button, { use: "primary", size: "medium", onClick: this.handleClose, children: rating ? 'Оценить и закрыть' : 'Закрыть окно' }));
            }
            if (isTypeShort) {
                return (_jsx(Button, { use: "primary", size: "medium", onClick: this.handleClose, disabled: !rating, children: "\u041E\u0446\u0435\u043D\u0438\u0442\u044C \u0438 \u0437\u0430\u043A\u0440\u044B\u0442\u044C" }));
            }
            return null;
        };
        return (_jsxs(Modal, { width: 550, onClose: onClose, children: [_jsx(Modal.Header, { children: isTypeFull && this.headerText }), _jsxs(Modal.Body, { children: [textTop, _jsxs("div", { className: classes.starsField, children: [_jsx("div", { className: classes.stars, children: RateInfos.map((info, index) => (_jsx("div", { className: clsx([classes.star, this.state.rating === info && classes.starActive]), "data-component": "star", onClick: () => this.handleStarClick(info), onMouseOver: () => this.handleStarMouseOver(info), onMouseOut: this.handleStarMouseOut }, index))) }), _jsx("div", { className: clsx([classes.caption, Boolean(hoverRating || rating) && classes.captionActive]), children: ratingCaption })] }), (commentOpened || rating || isTypeShort) && (_jsxs("div", { children: [_jsxs("div", { className: classes.field, children: [_jsx("div", { className: classes.label, children: "\u041A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0439 \u0438\u043B\u0438 \u043F\u043E\u0436\u0435\u043B\u0430\u043D\u0438\u0435" }), _jsx(Textarea, { autoResize: true, resize: "none", width: "100%", placeholder: rating?.text ?? 'Расскажите, что мы могли бы улучшить', value: this.state.message, onValueChange: (message) => this.setState({ message: message }) })] }), _jsxs("div", { className: classes.field, children: [_jsx("div", { className: classes.label, children: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D \u0438\u043B\u0438 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0447\u0442\u0430" }), _jsx(Input, { width: "100%", placeholder: "\u0423\u043A\u0430\u0436\u0438\u0442\u0435, \u0435\u0441\u043B\u0438 \u0445\u043E\u0442\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043C\u044B \u0441\u0432\u044F\u0437\u0430\u043B\u0438\u0441\u044C \u0441 \u0432\u0430\u043C\u0438", value: this.state.contactInfo, onValueChange: (contactInfo) => this.setState({ contactInfo: contactInfo }) })] })] }))] }), _jsx(Modal.Footer, { panel: true, children: _jsxs(Gapped, { gap: 8, children: [primaryButton(), onBackClick && (_jsx(Button, { size: "medium", onClick: onBackClick, children: "\u0412\u0435\u0440\u043D\u0443\u0442\u044C\u0441\u044F \u043A \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0443" }))] }) })] }));
    }
}
